module.exports = __webpack_public_path__ + "static/img/18022B_2_3_R_20190809_fit.d7753f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18022B_2_3_R_20190809_fit.png
// module id = Vd/F
// module chunks = 0